import microservice from './microservice';
var VARIANTS = {
  microservice: microservice
};
/**
 * @param {string} variant
 * @returns {import("theme/types").PartialEcrionTheme}
 */

export var getVariant = function getVariant(variant) {
  return VARIANTS[variant];
};
export default VARIANTS;